module.exports = __webpack_public_path__ + "img/arrowUp.026c2b50.svg";